import { contractManager } from '../model';

export const reloadContract = () => {
  const { id, forceUpdate } = contractManager;
  if (!id) return;
  contractManager.forceUpdate = forceUpdate > 100 ? 1 : forceUpdate + 1;
};
